import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { trackEvent } from 'analytics/trackFunctions'

import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'

import ErrorIcon from 'assets/icons/ErrorIcon'

const DefaultError = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_error' })
  }, [])

  return (
    <PageWrapper noTabBar viewSelected='/home' title='Error'>
      <section className='h-[calc(100vh-10rem)] text-black mx-auto flex flex-col justify-center sm:max-w-[22.5rem]'>
        <div className='mx-auto pt-8 text-center'>
          <ErrorIcon className='mx-auto' />
          <h1 className='font-bold mt-4 text-4xl'>¡Oops!</h1>
          <p className='font-bold text-gray-900 text-xl mb-16'>
            Ha ocurrido un error
          </p>
        </div>
        <PrimaryButton
          className='mt-auto md:mt-2'
          buttonText='Ir al inicio'
          primaryButtonFunction={() => {
            navigate('/home')
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default DefaultError
